import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const firebase = require('firebase');
require('firebase/firestore');

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBnLGkXSuhkkdm_FEnaKug5eNAFK9Iijm4",
    authDomain: "duly-noted-db2f1.firebaseapp.com",
    databaseURL: "https://duly-noted-db2f1.firebaseio.com",
    projectId: "duly-noted-db2f1",
    storageBucket: "duly-noted-db2f1.appspot.com",
    messagingSenderId: "824463858465",
    appId: "1:824463858465:web:8421613a3a923f7e54bc60",
    measurementId: "G-0L31P8HV5F"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
